export default class ToolbarModel {
    
    public searchTerm: string = "";
    
    reportDefinitionId: string | null = null;

    serviceReportDefinitionId: string | null = null;

}